var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sign"}},[_c('backHead'),_c('div'),_c('div',{staticClass:"Login_content"},[(_vm.isLoginType)?_c('loginDiv',{attrs:{"value":_vm.value},on:{"TabChangeBox":_vm.TabChangeBox}}):_c('signDiv',{attrs:{"value":_vm.value,"Invite":_vm.Invite},on:{"TabChangeBox":_vm.TabChangeBox}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }